// Shared building blocks used by the origami glyph SVGs.
// All glyphs share a paper-fold style: pastel paper fills with darker
// shaded fold-faces, dark outlines, dashed crease lines, beady eyes.

import type { CSSProperties, ReactElement } from 'react'

export const STROKE = '#2a221a'
export const SHADOW: CSSProperties = {
  filter: 'drop-shadow(2px 4px 0 rgba(42,34,26,0.18))',
}

interface PaperGradProps {
  id: string
  light: string
  dark: string
  x2?: number
  y2?: number
}

/**
 * Linear gradient definition for paper fills. Place inside an <svg>'s <defs>
 * and reference by id in fill="url(#myId)" attributes.
 */
export const PaperGrad = ({
  id,
  light,
  dark,
  x2 = 0.7,
  y2 = 1,
}: PaperGradProps): ReactElement => (
  <linearGradient id={id} x1="0" y1="0" x2={String(x2)} y2={String(y2)}>
    <stop offset="0%" stopColor={light} />
    <stop offset="100%" stopColor={dark} />
  </linearGradient>
)

interface BeadyEyeProps {
  cx: number
  cy: number
  r?: number
}

/**
 * Tiny black eye with a single white highlight dot. The signature
 * facial feature that gives the origami creatures their character.
 */
export const BeadyEye = ({ cx, cy, r = 1.8 }: BeadyEyeProps): ReactElement => (
  <>
    <circle cx={cx} cy={cy} r={r} fill="#2a221a" />
    <circle cx={cx - r * 0.4} cy={cy - r * 0.4} r={r * 0.32} fill="#fff" />
  </>
)

/** Standard prop shape for all origami glyph components. */
export interface GlyphProps {
  size?: number
}
